<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br_tbl_td_bottom {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.br_tbl_td_no_borders {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
}

tr:hover {
    background-color: transparent !important;
}

.br_rd_odd {
    background-color: rgba(0, 0, 0, .03) !important;
}

.rc_section {
    padding-top: 12px;
}

.br_label {
    color: rgba(0, 0, 0, 0.6);
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    padding-bottom: 16px;
}

.br_section {
    padding-bottom: 16px;
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.v-label {
    font-size: 20px;
}

.msg_ok {
    color: rgba(0, 200, 0);
}

.msg_err {
    color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
    <div class="pppoe_settings">
        <div class="br_section"><h2 class="br">CoA server</h2></div>
        <ValidationObserver ref="observer" v-slot="{ invalid }">

            <ValidationProvider rules="required" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.secret"
                    label="CoA shared secret"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

        </ValidationObserver>

        <v-toolbar flat>
            <span class="msg_ok">{{ ok_msg_text }}</span>
            <span class="msg_err">{{ err_msg_text }}</span>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancel()">
                Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="invalid"
                    text @click="save()">
                Save</v-btn>
        </v-toolbar>
    </div>
</template>

<script>

import api_client from '../services/api.js';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import "../validation_rules.js"

export default {
    name: 'coa',
    components: { 
        ValidationObserver, ValidationProvider, Treeselect
    },

    data: () => ({
        ok_msg_text: "",
        err_msg_text: "",

        settings: {
            secret: '',
        },
        old_settings: {},
    }),

    created() {
        this.initialize();
    },

    methods: {
        clear_msgs() {
            this.ok_msg_text = "";
            this.err_msg_text = "";
        },

        initialize() {
            return new Promise((resolve, reject) => {
                api_client.run_get_query("/coa/settings")
                .then(response => {
                    this.settings = response.data;
                    this.old_settings = Object.assign({}, this.settings);
                })
                .catch(error => {
                    console.log(error);
                });
            });
        },

        save() {
            api_client.run_post_query('/coa/save_settings', this.settings)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.err_msg_text = "";
                    this.ok_msg_text = "CoA settings have been successfully updated";
                    setTimeout(this.clear_msgs, 3000);
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        cancel() {
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
            this.clear_msgs();
            this.initialize();
        },        
    }
};
</script>
